export default "__VITE_ASSET__BST_jeTc__"